export class BrowserTestUtil {
    static runDiagnostics(): void {
        const ua = navigator.userAgent;
        console.log('[Browser Diagnostics] Full User Agent:', ua);

        // Детальная проверка iOS
        const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
        const isIPadOS = (ua.includes('Macintosh') && 'ontouchend' in document);
        const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
        const isChrome = /CriOS/.test(ua);
        const isFirefox = /FxiOS/.test(ua);

        // Проверка версии iOS
        const iosVersion = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);

        console.log('[Browser Diagnostics] Detection results:', {
            isIOS,
            isIPadOS,
            isSafari,
            isChrome,
            isFirefox,
            iosVersion: iosVersion ? `${iosVersion[1]}.${iosVersion[2]}` : 'unknown',
            platform: navigator.platform,
            vendor: navigator.vendor,
            maxTouchPoints: navigator.maxTouchPoints,
            standalone: (navigator as any).standalone,
            // Дополнительные проверки
            webkitAudioContext: 'webkitAudioContext' in window,
            audioWorklet: 'AudioWorklet' in window,
            mediaRecorder: 'MediaRecorder' in window,
            mediaRecorderTypes: this.getSupportedMediaTypes()
        });
    }

    static getSupportedMediaTypes(): string[] {
        if (!('MediaRecorder' in window)) return [];

        const types = [
            'audio/webm',
            'audio/webm;codecs=opus',
            'audio/webm;codecs=pcm',
            'audio/mp4',
            'audio/mp4;codecs=mp4a.40.2',
            'audio/wav',
            'audio/ogg;codecs=opus',
            'audio/mpeg',
            'audio/mp3'
        ];

        return types.filter(type => MediaRecorder.isTypeSupported(type));
    }

    static isRealIOSSafari(): boolean {
        const ua = navigator.userAgent;

        const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
        const isIPadOS = (ua.includes('Macintosh') && navigator.maxTouchPoints > 1);
        const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(ua);

        return (isIOS || isIPadOS) && isSafari;
    }
}